import { defineRecipe } from '@chakra-ui/react';
import { BorderWidths, Colors, FontWeights, Radii } from '../../types';

export const linkRecipe = defineRecipe({
  base: {
    fontWeight: FontWeights.LINK,
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    // TODO: post-Figma update -> thickness: min(2px, .0625em) / offset: min(3px, .25em)
    gap: 'min(.5ch, var(--udl-spacing-2xs))',
    px: 0.5,
    mx: -0.5,
    rounded: Radii.SM,
    '& svg': {
      lineHeight: '1lh',
      color: 'inherit',
      alignSelf: 'center',
    },
    _hover: {
      textDecoration: 'underline',
    },
    _disabled: {
      opacity: 1,
      color: Colors.TEXT_DISABLED,
    },
  },
  variants: {
    variant: {
      default: {
        color: Colors.TEXT_INTERACTIVE,
        _hover: {
          color: Colors.TEXT_INTERACTIVE_HOVER,
        },
        _active: {
          color: Colors.TEXT_INTERACTIVE_ACTIVE,
        },
        _visited: {
          color: Colors.TEXT_INTERACTIVE_ACTIVE,
        },
      },
      neutral: {
        color: Colors.TEXT_MUTED,
        textDecoration: 'underline',
        textDecorationColor: Colors.BORDER_MUTED,
        _hover: {
          color: Colors.TEXT_EMPHASIS,
          textDecorationColor: Colors.BORDER_EMPHASIS,
        },
        _active: {
          color: Colors.TEXT_EMPHASIS,
          textDecorationColor: Colors.CURRENT,
        },
        _visited: {
          color: Colors.TEXT_MUTED,
          textDecorationColor: Colors.BORDER_DEFAULT,
        },
      },
      abbr: {
        color: 'inherit',
        fontWeight: 'inherit',
        textDecorationStyle: 'dotted',
        textDecorationColor: 'color-mix(in srgb, currentColor 60%, transparent)',
        textDecorationThickness: BorderWidths.SM,
        _hover: {
          color: 'inherit',
        },
      },
      plain: {
        color: Colors.TEXT_INFO,
        fontWeight: 'unset',
        _hover: {
          color: Colors.TEXT_INFO_HOVER,
        },
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
